import { InjectionToken } from '@angular/core';

import { ENVIRONMENT } from 'src/configs/environment/environment';
import type { Environment } from 'src/configs/environment/environment.interface';

/**
 * ENVIRONMENT reference for dependency injection
 *
 * Usage:
 *
 * ```ts
 * class WhateverThing {
 *  constructor(
 *    @Inject(environmentRef) private readonly environment: Environment
 *  ) { }
 * ```
 *
 * Mocking in Tests:
 *
 * ``` ts
 * beforeEach(() => {
 *   TestBed.configureTestingModule({
 *     providers: [
 *       MockProvider(environmentRef,{ ... })
 *     ]
 *   });
 * });
 * ```
 */
export const environmentRef = new InjectionToken<Environment>('ENVIRONMENT', {
  providedIn: 'root',
  factory: () => ENVIRONMENT
});
